export const SEGMENT_OUT_META = {
  name: 'Segment',
  category: 'Data management',
  subCategory: 'Source',
};
